// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app_wrapper__3cDXJ","middleContainer":"app_middleContainer__3fudl","logoText":"app_logoText__2svOE","formLable":"app_formLable__125n9"};